/**
 * Exports select-related design tokens
 */

export const arrowIconGlyph = 'triangle-down';
export const arrowIconSize = 'xxsmall';
export const arrowIconColor = 'gray/10';
export const arrowIconDisabledColor = 'gray/60';
export const arrowAnimationEasing = 'ease-in-out/weak';